module.exports = __webpack_public_path__ + "static/media/step_learnnew.ac72c28f.svg";